import { render, staticRenderFns } from "./LockedConfirmation.vue?vue&type=template&id=8a8a5790&"
import script from "./LockedConfirmation.vue?vue&type=script&lang=js&"
export * from "./LockedConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports